import ReactApexChart from "react-apexcharts";
import { Card, CardBody, Col, Row } from "reactstrap";
import { CryptocurrencyPricesTitle } from "../../../../Constants/Constants";
import { CryptocurrencyPricesChart } from "../../../../Data/General/Widgets/Chart";
import CommonCardHeader from "../../../CommonComponents/CommonCardHeader/CommonCardHeader";

const CryptocurrencyPrices = () => {
  return (
    <Col xl="6" lg="12" className="xl-50">
      <Card>
        <CommonCardHeader title={CryptocurrencyPricesTitle} />
        <CardBody>
          <div className="chart-container crypto-chart">
            <Row>
              <Col xs="12">
                <div id="chart-crypto">
                  <ReactApexChart options={CryptocurrencyPricesChart} series={CryptocurrencyPricesChart.series} type="area" height={400} />
                </div>
              </Col>
            </Row>
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default CryptocurrencyPrices;
